import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { ValuationApiResponseDto, ValuationRequestDto, ValuationResponseDto } from '../../@types/valuation-types'
import { getDefaultLogger } from '../../services/logger/logger'

const toValuationResponseDto = ({ value, valueMin, valueMax }: ValuationApiResponseDto): ValuationResponseDto => ({
  maxValue: valueMax,
  minValue: valueMin,
  recommendedValue: value,
})

export const postRentValuation = async (
  valuationRequest: ValuationRequestDto
): Promise<ValuationResponseDto | undefined> => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include' as const,
    body: JSON.stringify(valuationRequest),
  }

  const response = await customFetch(`${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/valuation/rent`, options)

  if (response.status === 200) {
    const apiResponse = (await response.json()) as ValuationApiResponseDto
    return toValuationResponseDto(apiResponse)
  }

  getDefaultLogger().warn('Failed to load rent valuation from valuation API', response)
  return undefined
}
